import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  VehicleNavigationData,
  VehicleQueryParams
} from '../components/vehicle-navigation/interfaces/vehicle-navigation.interfaces';

@Injectable({
  providedIn: 'root'
})
export class VehicleNavigationService {
  private readonly basePath: string[] = ['master', 'transport', 'transport-vehicle'];

  constructor(private router: Router) {}

  navigateToVehicleList(
    queryParams: VehicleQueryParams = {},
    openInNewTab: boolean = true
  ): void {
    const urlTree = this.router.createUrlTree(this.basePath, { queryParams });

    if (openInNewTab) {
      const url = window.location.origin + this.router.serializeUrl(urlTree);
      window.open(url, '_blank');
    } else {
      this.router.navigateByUrl(urlTree);
    }
  }

  navigateToVehicleDetail(
    vehicle: VehicleNavigationData,
    additionalParams: VehicleQueryParams = {},
    openInNewTab: boolean = true
  ): void {
    const searchTerm = this.getSearchTerm(vehicle);
    const queryParams: VehicleQueryParams = {
      search: searchTerm,
      ...additionalParams
    };

    this.navigateToVehicleList(queryParams, openInNewTab);
  }

  createVehicleUrl(queryParams: VehicleQueryParams = {}): string {
    const urlTree = this.router.createUrlTree(this.basePath, { queryParams });
    return window.location.origin + this.router.serializeUrl(urlTree);
  }

  isVehicleNavigable(vehicle: VehicleNavigationData): boolean {
    if (!vehicle) return false;
    return !!vehicle.code || !!vehicle.externalKeys?.code || !!vehicle.name;
  }

  getNavigationDescription(): string {
    return 'Ver en Vehículos';
  }

  private getSearchTerm(vehicle: VehicleNavigationData): string {
    if (!vehicle) return '';
    return vehicle.code || vehicle.externalKeys?.code || vehicle.name || '';
  }
}
